import React, { useState, useRef, useEffect } from 'react';
import InterfacesTab from './UserScreens/InterfacesTab/InterfacesTab';
import WANTab from './UserScreens/WANTab/WANTab';
import LANTab from './UserScreens/LANTab/LANTab';
import WiFiTab from './UserScreens/WiFiTab/WiFiTab';
import DeviceConfigModal from './components/Modals/DeviceConfigModal';
import SystemTab from './UserScreens/SystemTab/SystemTab';
import TransferTab from './UserScreens/TransferTab/TransferTab';
import ConfirmDialog from '../../../components/ConfirmDialog';
import CommonModal from './components/Modals/CommonModal';
import { Box } from '@mui/material';
import { getDeviceDeatilsData, getOESyncStatusData, getAMavailibility, getOpenEdgeSOftwareUpdateStatusData } from '../../../actions/Users/authenticateOpenEdgeService';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { GET_DEVICE_DETAILS, GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS } from '../../../actions/types';
import _ from 'lodash';
import { CONFIRM_DIALOG_TITLE } from '../../../config';
import { getGeneratedLinks } from '../../../components/RemoteConnections/remoteConnectionSlice';
import { displayToastError } from '../../../server/request';
import { getDataFromLocalStorageParsed } from '../../../utils/util';
import { clearData } from '../../QuotaManagement/slice';
import { SYNC_DELAY } from '../../../utils/delayTimeout';
import SecurityTab from './UserScreens/SecurityTab/SecurityTab';
import CellularTab from './UserScreens/CellularTab/CallularTab';
import AssignInventory from '../../../components/InventoryWarehouseTable/AssignInventory';
import HubTab from './UserScreens/HubTab/HubTab';

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  row: any;
  deviceName?: string;
  isValidTier: boolean;
  confirmDialog: any,
  setConfirmDialog: any;
  getDeviceDeatilsData: any;
  getDeviceDeatils: any;
  topology?: boolean
  getGeneratedLinks: any
  getOESyncStatus: any;
  getOESyncStatusData: any;
  getAMavailibility: any;
  isAMavailable: any;
  simPriorityDetails: any;
  getSOftwareUpdateStatus: any;
  getOpenEdgeSOftwareUpdateStatusData: any;
  isLicenseChanging?: boolean;
  onLicenseChangeSuccess?: () => void;
}

type WanTabRefType = {
  saveWanProfileConfig: () => void;
  getHasUnsavedChanges: () => boolean;
};

type CellTabRefType = {
  saveSimPrioritySettings: () => void;
};

type FirewallTabRefType = {
  saveIdentityRuleSettings: () => void;
};


const getOnlineStatusText = (status: string | null | undefined): string => {
  if (status === 'STATUS_CONNECTED') return 'Online';
  if (status === 'STATUS_NOT_CONNECTED') return 'Offline';
  return 'Unknown';
};

const InventoryPopup: React.FC<Props> = ({ open, setOpen, row, deviceName, isValidTier, confirmDialog, setConfirmDialog, getDeviceDeatilsData, getDeviceDeatils, topology, getGeneratedLinks, getOESyncStatusData, getOESyncStatus, getAMavailibility, isAMavailable, simPriorityDetails, getSOftwareUpdateStatus, getOpenEdgeSOftwareUpdateStatusData, isLicenseChanging, onLicenseChangeSuccess }) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(row?.licenseTier == "T103" ? 3 : 0);
  const [redirectProfileId, setRedirectProfileId] = useState<string | null>(null);
  const [rememberedProfileId, setRememberedProfileId] = useState<string | null>(() => {
    return sessionStorage.getItem("wanProfileId") || null;
  });
  const [hasUnsavedWanChanges, setHasUnsavedWanChanges] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [wanSelectedProfileId, setWanSelectedProfileId] = useState<string | null>(() => {
    return sessionStorage.getItem("wanProfileId") || null;
  });
  const [wanProfileSwitched, setWanProfileSwitched] = useState(false);
  const [wanNewProfileCreated, setWanNewProfileCreated] = useState(false);
  const [wanModalOpenCount, setWanModalOpenCount] = useState(0);
  const savedTempProfilesRef = useRef<Set<string>>(new Set());
  const [deviceInfo, setdeviceInfo] = useState<any>();
  const dispatch = useDispatch();

  const [refreshIconClicked, setRefreshIconClicked] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(1);
  const [syncStatus, setSyncStatus] = useState('Synced');
  const [isAMthere, setIsAMthere] = useState(false);
  const timeoutRef = useRef<any>(null);
  const oeSyncRetryCount = useRef(0);
  const [redirectedTab, setRedirectedTab] = useState<any>('');
  const [showFooter, setShowFooter] = useState(false);
  const [currentEOSVersion, setCurrentEOSVersion] = useState(row['current_EOS_version']);
  const [upgradePolling, setUpgradePolling] = useState(false);
  const upgradePollingRef = useRef<any>(null);
  const [deviceDateRegistered, setDeviceDateRegistered] = useState('');
  localStorage.setItem("inventoryK4id",row?.k4Id)

  useEffect(() => {
    if (!refreshIconClicked) {
      setSyncStatus("Syncing");
      oeSyncRetryCount.current = 0;
      getOESyncStatusData(row["deviceId"]);
    }
  }, [refreshIconClicked]);

  useEffect(() => {
    if (open) {
      let interval: any;
      setWanModalOpenCount((prev) => prev + 1);
      sessionStorage.removeItem("wanProfileWasSaved");
      oeSyncRetryCount.current = 0;
      getDeviceDeatilsData(row?.['deviceId']);
      getOESyncStatusData(row["deviceId"]);
      getOpenEdgeSOftwareUpdateStatusData(row['k4Id'], row['deviceId']);
      let payload = {};
      getAMavailibility(row?.k4Id,row?.deviceId, payload);//to update amcontroller action status
      interval = setInterval(getAMavailibility(row?.k4Id,row?.deviceId, payload), 30000);
      return () => clearInterval(interval);
    } else {
      setUpgradePolling(false);
    }
  }, [open]);

  useEffect(() => {
    if (!_.isEmpty(getSOftwareUpdateStatus)) {
      const response = getSOftwareUpdateStatus.hasOwnProperty('data') ? getSOftwareUpdateStatus.data?.[0] : {};
      if (response?.date_registered) setDeviceDateRegistered(response.date_registered);
      const status = response?.status?.toLowerCase() || "";
      const inProgressStatuses = ["request received", "download initiated", "download inprogress", "installation inprogress", "scheduled"];

      if (status === "upgraded" || status === "eos up to date") {
        if (response?.current_sw_version) setCurrentEOSVersion(response.current_sw_version);
        setUpgradePolling(false);
      } else if (status === "failed") {
        setUpgradePolling(false);
      } else if (inProgressStatuses.some(s => status.includes(s))) {
        setUpgradePolling(true);
      }
    }
  }, [getSOftwareUpdateStatus]);

  useEffect(() => {
    if (upgradePolling) {
      upgradePollingRef.current = setInterval(() => {
        getOpenEdgeSOftwareUpdateStatusData(row['k4Id'], row['deviceId']);
      }, 30000);
    } else {
      if (upgradePollingRef.current) {
        clearInterval(upgradePollingRef.current);
        upgradePollingRef.current = null;
      }
    }
    return () => {
      if (upgradePollingRef.current) {
        clearInterval(upgradePollingRef.current);
        upgradePollingRef.current = null;
      }
    };
  }, [upgradePolling]);

  useEffect(() => {
    if (!_.isEmpty(getDeviceDeatils)) {
      const data = getDeviceDeatils;
      const isRouter = data?.is_router;
      const isAP = data?.is_ap;

      const type = isAP ? "ap" : isRouter ? "router" : null;
      setdeviceInfo(type);
      dispatch({ type: GET_DEVICE_DETAILS, payload: {} })
    }
  }, [getDeviceDeatils])

  useEffect(() => {
    if (!_.isEmpty(isAMavailable)) {
      const data = isAMavailable;
      setIsAMthere(data?.data?.oe_response?.data?.statusBoolean || false);
    }
  }, [isAMavailable])


  const forceRemountWANTab = () => {
    setWanModalOpenCount(prev => {
      const newCount = prev + 1;
      return newCount;
    });
  };

  const wanRef = useRef<WanTabRefType | null>(null);
  const cellRef = useRef<CellTabRefType | null>(null);
  const firewallRef = useRef<FirewallTabRefType | null>(null);

  const isHubSupported = !['T101', 'T103'].includes(row?.tierValue);
  const tabs = ['Interfaces', 'WAN', 'LAN', 'Wi-Fi', isHubSupported ? 'Hub' : null, 'Firewall', 'Cellular', 'System', 'Association', row?.licenseType == 'None' ? 'Register' : null].filter((tab): tab is string => Boolean(tab));
  const isRMDevice = row?.deviceId?.startsWith('RM');
  const filteredTabs = (isAMthere || isRMDevice) ? tabs : tabs.filter(tab => tab !== 'Cellular');

  let disabledTabs: number[] = row?.licenseTier == "T103"
    ? ['WAN', 'Firewall'].map(tab => filteredTabs.indexOf(tab)).filter(i => i !== -1)
    : [];
  const handleTabChange = (tabName: string, index: number, profileId?: string, redirectTab?: string) => {
    if (index === 1 && profileId) {
      setRedirectProfileId(profileId);
    }
    setActiveTabIndex(index);
    setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
    setRefreshIconClicked(true);
    setRefreshTrigger(1);
    dispatch({ type: GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, payload: {} })
    setRedirectedTab(redirectTab)
  };

  useEffect(() => {
    // Default footer visibility per main tab
    if (activeTabIndex === 1) {
      // WAN
      setShowFooter(true);
    } else {
      // LAN, WIFI, SYSTEM, etc.
      setShowFooter(false);
    }
  }, [activeTabIndex]);


  const handleSave = () => {
    if (activeTabIndex === 1 && wanRef.current?.saveWanProfileConfig) {
      wanRef.current.saveWanProfileConfig();
    }else if(filteredTabs[activeTabIndex] === "Cellular" && cellRef.current?.saveSimPrioritySettings){
      cellRef.current.saveSimPrioritySettings();
    }else if(filteredTabs[activeTabIndex] === "Firewall" && firewallRef.current?.saveIdentityRuleSettings){
      firewallRef.current.saveIdentityRuleSettings();
    }
  };

  const handleCancel = () => {
    const hasAnyUnsavedLocally = Object.keys(localStorage).some(key =>
      key.startsWith('wan_unsaved_') && localStorage.getItem(key) === 'true'
    );

    const wanProfileWasSaved = sessionStorage.getItem("wanProfileWasSaved") === "true";
    const hasAnyUnsaved =
      (hasUnsavedWanChanges || wanProfileSwitched || wanNewProfileCreated || hasAnyUnsavedLocally) &&
      !wanProfileWasSaved;

    if (hasAnyUnsaved) {
      setShowUnsavedModal(true);
    } else {
      setOpen(false);
    }
    dispatch({ type: GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS, payload: {} });
  };


  const renderTabContent = (index: number): JSX.Element | null => {
    const currentTab = filteredTabs[index];
    switch (currentTab) {
      case "Interfaces":
        return <InterfacesTab selectedRow={row} handleTabChange={handleTabChange} deviceInfo={deviceInfo} refreshIconClicked={refreshTrigger} setRefreshIconClicked={setRefreshIconClicked} />;
      case "WAN":
        return <WANTab
          row={row}
          wanRef={wanRef}
          rememberedProfileId={wanSelectedProfileId}
          setRememberedProfileId={setWanSelectedProfileId}
          redirectProfileId={redirectProfileId}
          setRedirectProfileId={setRedirectProfileId}
          setHasUnsavedChanges={setHasUnsavedWanChanges}
          setProfileSwitched={setWanProfileSwitched}
          setNewProfileCreated={setWanNewProfileCreated}
          modalOpenCount={wanModalOpenCount}
          forceRemountWANTab={forceRemountWANTab}
          savedTempProfilesRef={savedTempProfilesRef}
          deviceInfo={deviceInfo}
          refreshIconClicked={refreshTrigger}
          redirectedTab={redirectedTab}
          setShowFooter={setShowFooter} />
      case "LAN":
        return <LANTab selectedRow={row} deviceInfo={deviceInfo} refreshIconClicked={refreshTrigger} setRefreshIconClicked={setRefreshIconClicked} />;
      case "Wi-Fi":
        return <WiFiTab selectedRow={row} deviceInfo={deviceInfo} refreshIconClicked={refreshTrigger} setRefreshIconClicked={setRefreshIconClicked} />;
      case "Hub":
        return <HubTab key="hub-tab" selectedRow={row} dateRegistered={deviceDateRegistered} refreshIconClicked={refreshTrigger} />;
      case "Firewall":
        return <SecurityTab firewallRef={firewallRef} selectedRow={{ ...row, current_EOS_version: currentEOSVersion }} refreshIconClicked={refreshTrigger} setOpen={setOpen} setShowFooter={setShowFooter}/>;
      case "Cellular": {
        return <CellularTab
          cellRef={cellRef}
          selectedRow={row}
          setShowFooter={setShowFooter}
          refreshIconClicked={refreshTrigger}
          setSyncStatus={setSyncStatus}
        />
      }
      case "System":
        return <SystemTab row={row} isValidTier={isValidTier} deviceName={deviceName} confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} topology={topology} refreshIconClicked={refreshTrigger} setOpen={setOpen} deviceInfo={deviceInfo} />;
      case "Association":
        return <TransferTab row={row} refreshIconClicked={refreshTrigger} setOpen={setOpen} onLicenseChangeSuccess={onLicenseChangeSuccess} />;
      case "Register":
        return <AssignInventory row={row} setOpen={setOpen} deviceOu={{ "id": row["dpId"], "name": row["dpname"] }} tab='deployed-RS' />;
      
      default:
        return null;
    }
  };

  const EDGE_PORTAL_ADDRESS = "127.0.0.1"
  const EDGE_PORTAL_PORT = 80
    const onConnectToEdge = async () => {
          // e.preventDefault()
          let resp:any = await getGeneratedLinks(row?.k4Id, row?.deviceId, { address: [EDGE_PORTAL_ADDRESS] })
          if (!_.isEmpty(resp?.result)) {
              let [edgeLink] = resp.result?.filter(rc => {
                  return rc?.address === EDGE_PORTAL_ADDRESS && rc.port === EDGE_PORTAL_PORT && rc.alias.includes("Portal")
              });
              if (edgeLink && edgeLink.url) {
                  let url = edgeLink.url;
                  const loggedInUser = getDataFromLocalStorageParsed("loggedInUser");
                  let edgeToken = loggedInUser?.data?.edge_token;
                  if (!_.isEmpty(edgeToken)) {
                      let objUrl = new URL(`/login?token=${edgeToken}`, `${url}`)
                      url = objUrl?.href
                  }
                  window.open(url)
                  clearData()
              }
          } else {
              displayToastError('No remote connection link found')
          }
      }

  useEffect(() => {
    if (!_.isEmpty(getOESyncStatus)) {
      // Cellular tab manages syncStatus itself; skip OE sync override
      if (filteredTabs[activeTabIndex] === "Cellular") return;

      if (getOESyncStatus.hasOwnProperty('status') && !getOESyncStatus?.status) {
        setSyncStatus("Syncing");
        return;
      }

      const { in_progress, resync_required } = getOESyncStatus?.data ?? getOESyncStatus;
      if (in_progress || resync_required) {
        setSyncStatus("Syncing");

        if (oeSyncRetryCount.current < 6) {
          oeSyncRetryCount.current += 1;
          timeoutRef.current = setTimeout(() => {
            getOESyncStatusData(row["deviceId"]);
          }, SYNC_DELAY);
        } else {
          oeSyncRetryCount.current = 0;
          setSyncStatus("Synced");
        }
      } else {
        oeSyncRetryCount.current = 0;
        setSyncStatus("Synced");
      }
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [getOESyncStatus, activeTabIndex])
      
  return (<>
    <DeviceConfigModal
      open={open}
      setOpen={setOpen}
      deviceName={deviceName || row?.deviceName}
      cancelText="Cancel"
      saveText={"Save"}
      tabLabels={filteredTabs}
      activeTabIndex={activeTabIndex}
      onTabSwitch={handleTabChange}
      onSave={handleSave}
      onCancel={handleCancel}
      renderTabContent={renderTabContent}
      showOnlineStatus={getOnlineStatusText(row?.konnect_status) == "Online" ? true : false}
      onlineStatusText={getOnlineStatusText(row?.konnect_status)}
      isEssential={row?.tierValue == "T101" ? true : false}
      lastSeen={row?.last_seen}
      disableSave={false}
      showRefreshIcon={true}
      setRefreshIconClicked={setRefreshIconClicked}
      refreshIconClicked={refreshIconClicked}
      setRefreshTrigger={setRefreshTrigger}
      onConnectToEdge={onConnectToEdge}
      disabledTabs={disabledTabs}
      showOnlineOffline={false}
      showKonnectStatusWithHeader={true}
      footer={showFooter}
      syncStatus={syncStatus}
      showSyncStatus={true}
    />


    <CommonModal
      open={showUnsavedModal}
      onClose={() => setShowUnsavedModal(false)}
      onSave={() => {
        setHasUnsavedWanChanges(false);
        setShowUnsavedModal(false);
        setOpen(false);
        sessionStorage.removeItem("wanProfileWasSaved");
        Object.keys(localStorage).forEach(key => {
          if (
            key.startsWith('bondingData_') ||
            key.startsWith('unusedWanLinks_') ||
            key.startsWith('wan_unsaved_') ||
            key.startsWith('wanNewProfileName_')
          ) {
            localStorage.removeItem(key);
          }
        });
        localStorage.removeItem('wanRenamedProfilesCache');
      }}
      title="Unsaved Changes"
      cancelText="Cancel"
      saveText="Proceed"
      titleWithDeleteIcon={true}
      maxWidth="430px"
      showOnlineOffline={false}
      showSyncStatus={false}
    >
      <Box
        sx={{
          padding: '16px 24px',
          fontSize: '14px',
          color: '#3A3C4A',
          textAlign: 'center',
          lineHeight: '22px',
        }}
      >
        You have unsaved changes in the WAN tab. <br />
        Do you want to discard them and close the popup?
      </Box>
    </CommonModal>

  </>

  );
};

const mapStateToProps = (state) => ({
  getDeviceDeatils: state.authReducer.getDeviceDeatils,
  getOESyncStatus: state.authReducer.getOESyncStatus,
  isAMavailable: state.authReducer.isAMavailable,
  simPriorityDetails: state.authReducer.simPriorityDetails,
  getSOftwareUpdateStatus: state.authReducer.getOpenEdgeSoftwareUpdateStatus,
});

export default withRouter(
  connect(mapStateToProps, { getDeviceDeatilsData, getGeneratedLinks, getOESyncStatusData, getAMavailibility, getOpenEdgeSOftwareUpdateStatusData })(InventoryPopup)
)